var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCarTopView = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 333,
    viewBox: "0 0 180 333",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 44.1645C16.4999 15.4302 50.9998 -0.835767 91.4998 1.16538C117 2.42537 139.5 8.66406 149.5 16.1639C159.409 23.5951 162.591 29.7823 162.3 42.1647C159.5 161.164 167 296.664 155.5 313.664C152.418 318.22 148.688 322.623 144 325.164C130.5 329.664 112.451 331.623 89.4998 331.664C72.7381 331.694 58.9998 330.164 41.4998 326.664C34.9998 325.364 29.0143 322.086 24.9998 315.664C20.4998 306.164 17.5001 294 17.5001 270.164C17.5001 246.328 16.5002 90.1651 16.5 44.1645Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6471 327.502C44.6158 327.533 44.6157 327.565 44.6157 327.565C37.9471 326.218 32.3429 324.308 29.3999 321.678C25.0794 317.795 21.9799 309.153 19.9448 299.352C19.9448 299.352 20.07 299.289 20.2579 299.196C21.9172 298.475 29.6191 295.438 31.5289 300.385C33.6579 305.99 43.0816 321.365 44.6157 322.148C46.0559 322.868 44.8036 326.938 44.6471 327.502Z",
    fill: "#FFF6F0",
    stroke: "#000",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.517 299.197C159.674 299.26 159.768 299.291 159.831 299.322C157.795 309.123 154.696 317.797 150.375 321.679C147.432 324.31 141.828 326.188 135.191 327.566C135.191 327.566 135.191 327.535 135.16 327.503C135.003 326.94 133.751 322.869 135.191 322.149C136.725 321.366 146.18 305.992 148.278 300.387C150.156 295.502 157.733 298.414 159.517 299.197Z",
    fill: "#FFF6F0",
    stroke: "#000",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1126 115.549L17.4088 119.588",
    stroke: "#000",
    strokeWidth: 2.02164,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9386 102.49C19.819 102.02 22.8246 102.145 25.7363 103.022",
    stroke: "#000",
    strokeWidth: 2.02164,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9596 327.564C44.8657 327.533 44.7405 327.533 44.6466 327.502C38.1031 326.155 32.6241 324.276 29.7438 321.677C25.4232 317.795 22.3237 309.152 20.2887 299.352",
    stroke: "#000",
    strokeWidth: 2.02164,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.487 299.32C157.452 309.121 154.352 317.795 150.032 321.678C147.151 324.277 141.672 326.124 135.16 327.502C135.066 327.533 134.941 327.533 134.847 327.564",
    stroke: "#000",
    strokeWidth: 2.02164,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9595 327.564C63.4001 331.353 89.887 331.04 89.887 331.04C89.887 331.04 116.405 331.353 134.846 327.564",
    stroke: "#000",
    strokeWidth: 2.02164,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.673 102.209C162.835 54.7389 163.336 35.1372 161.114 31.2857C158.421 26.6202 148.841 1.66406 89.887 1.66406C30.902 1.66406 21.3529 26.5262 18.6291 31.2857C16.7819 34.5109 16.3436 76.595 16.9384 102.491C12.023 103.336 7.51457 106.06 4.44635 110.256C4.44635 110.256 1.50339 113.857 1.69124 115.986C1.78517 117.082 2.28607 119.681 2.88093 120.777C4.41504 123.501 8.32859 123.814 11.1463 122.468L17.408 119.587C17.4393 121.122 17.4706 121.967 17.4706 121.967C15.6861 121.059 18.9735 246.591 17.4706 259.21C16.6566 265.974 17.0636 283.916 20.2571 299.196C20.2571 299.259 20.2884 299.29 20.2884 299.353",
    stroke: "#000",
    strokeWidth: 2.02164,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M159.486 299.322C159.486 299.29 159.518 299.228 159.518 299.196C162.68 283.916 161.772 266.005 162.273 259.21C163.024 248.564 162.241 194.675 161.897 157.57C161.834 150.023 161.772 143.166 161.772 137.53C161.741 126.32 161.866 119.807 162.273 121.967C162.273 121.967 162.304 121.122 162.335 119.556L168.597 122.468C171.446 123.815 175.36 123.502 176.863 120.777C177.489 119.681 177.99 117.082 178.084 115.986C178.24 113.857 175.297 110.256 175.297 110.256C172.26 106.06 167.752 103.336 162.836 102.491L159.768 102.209",
    stroke: "#000",
    strokeWidth: 2.02164,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M130.119 15.0946C130.307 13.6855 131.716 12.7774 133.469 13.5602L143.582 18.7894C147.37 20.7308 150.626 23.7681 153.037 27.463C155.447 31.1265 157.044 35.4164 157.451 39.8941C157.639 41.7728 156.011 42.9 154.446 41.9293L137.977 32.0033C132.843 28.9034 129.618 22.6408 130.025 16.5975L130.119 15.0946Z",
    fill: "#FFF6F0",
    stroke: "#000",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7075 27.463C29.1495 23.7681 32.4056 20.7308 36.1939 18.7894L46.3065 13.5602C48.0598 12.7774 49.4374 13.6855 49.6565 15.0946L49.7504 16.5975C50.1574 22.6408 46.9014 28.9034 41.7668 32.0033L25.33 41.9293C23.7645 42.9 22.1052 41.7728 22.293 39.8941C22.7314 35.4164 24.2967 31.1265 26.7075 27.463Z",
    fill: "#FFF6F0",
    stroke: "#000",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4381 136.467C35.3479 143.137 36.9132 149.055 36.9759 150.088C37.1637 152.718 34.8469 229.434 32.6866 253.232C32.6866 253.232 26.1745 202.944 26.1119 196.274C26.1119 196.274 25.2979 118.024 26.1119 115.55C26.5815 114.016 30.4324 126.134 33.4381 136.467Z",
    fill: "#FFF6F0",
    stroke: "#000",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.224 241.893V292.995C136.224 292.995 110.488 299.351 89.8874 299.351C69.2552 299.351 43.551 292.995 43.551 292.995V241.893C43.551 241.893 78.272 245.462 89.8874 245.462C101.503 245.462 136.224 241.893 136.224 241.893Z",
    fill: "#FFF6F0",
    stroke: "#000",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.635 134.303L138.573 134.522C137.915 136.839 135.817 138.436 133.407 138.436H46.3381C43.9587 138.436 41.861 136.839 41.2036 134.522L41.1409 134.303L31.905 101.299L29.2438 91.7486C28.7428 89.9638 29.2125 88.0537 30.4648 86.676C35.0984 81.6033 49.6255 70.957 89.8881 70.957C130.119 70.957 144.646 81.6033 149.28 86.676C150.564 88.0537 151.033 89.9638 150.532 91.7486L147.871 101.299L138.635 134.303Z",
    fill: "#FFF6F0",
    stroke: "#000",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M153.945 156.82C153.851 176.704 153.663 196.274 153.663 196.274C153.601 202.944 147.057 253.232 147.057 253.232C144.928 229.434 142.611 152.718 142.768 150.088C142.831 149.055 144.396 143.137 146.306 136.467C149.311 126.134 153.162 114.016 153.663 115.55C153.914 116.364 154.008 125.633 154.008 137.563C154.008 143.544 153.976 150.213 153.945 156.82Z",
    fill: "#FFF6F0",
    stroke: "#000",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M162.337 119.557L153.665 115.549",
    stroke: "#000",
    strokeWidth: 2.02164,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.007 103.023C155.886 102.46 157.796 102.209 159.674 102.209C159.705 102.209 159.737 102.209 159.768 102.209C160.801 102.209 161.803 102.303 162.836 102.491",
    stroke: "#000",
    strokeWidth: 2.02164,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159.548 299.351C159.548 299.351 159.517 299.351 159.486 299.32",
    stroke: "#000",
    strokeWidth: 2.02164,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCarTopView, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/car_top_view.ffe82b65.svg";
export { ForwardRef as ReactComponent };